import { ChangeDetectorRef, Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ImporterComponent } from '../importer/importer.component';
import { MatStepper } from '@angular/material/stepper';
import { StepperSelectionEvent } from '@angular/cdk/stepper';

@Component({
    selector: 'app-file-importer',
    templateUrl: './file-importer.component.html',
    styleUrls: ['./file-importer.component.scss']
})
export class FileImporterComponent implements OnInit {

    public fileUploadFormGroup: FormGroup;

    @Input() public mode: 'inventory' | 'deck' = 'inventory';

    public source = '';

    public readonly dialogRef: MatDialogRef<FileImporterComponent>;
    public files: File[] = [];

    private readonly fileToValue: any = {};

    @ViewChild('importer', { static: true }) private readonly importer: ImporterComponent;
    @ViewChild('stepper', { static: true }) private readonly stepper: MatStepper;

    constructor(private readonly formBuilder: FormBuilder, private readonly injector: Injector, private readonly changeDetector: ChangeDetectorRef) {
        this.dialogRef = this.injector.get(MatDialogRef, null);
    }

    public ngOnInit() {
        this.fileUploadFormGroup = this.formBuilder.group({
            fileUpload: ['', Validators.required]
        });

        this.fileUploadFormGroup.get('fileUpload').valueChanges.subscribe((value: {name: string; value: string}) => {
            this.fileToValue[value.name] = value.value.replace(/\n/g, '<br>');
        });

        this.stepper.selectionChange.subscribe((event: StepperSelectionEvent) => {
            if (event.selectedIndex === 1) {
                for (const fileName in this.fileToValue) {
                    if (this.fileToValue.hasOwnProperty(fileName)) {
                        this.source += this.fileToValue[fileName] + '<br>';
                    }
                }
                setTimeout(() => this.importer.previewImport());
            }
        });
    }

    public importCards(cards): void {
        if (this.dialogRef) {
            this.dialogRef.close(cards);
        }
    }

    public cancel(): void {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }

    public triggerImport(): void {
        this.importer.getCardsToImport().subscribe(qtyAndCards => {
            if (this.dialogRef) {
                this.dialogRef.close(qtyAndCards);
            }
        });
    }

    public onFileSelected(event) {
        let file;
        if (event.target && event.target.files && event.target.files.length) {
            file = event.target.files[0];
        } else if (event.addedFiles) {
            file = event.addedFiles[0];
        }

        const reader = new FileReader();
        if (file && this.files.findIndex(f => f.name === file.name) < 0) {
            reader.readAsText(file, 'utf-8');

            reader.onload = () => {
                this.fileUploadFormGroup.patchValue({
                    fileUpload: {name: file.name, value: reader.result}
                });
                this.files.push(file);

                this.changeDetector.markForCheck();
            };
        }
    }

    public onRemove(fileName) {
        this.files = this.files.filter(f => f.name !== fileName);
        this.source = '';
        delete this.fileToValue[fileName];
    }

}
